import React from "react"

import {
  ChatProvider,
  LayerPopupProvider,
  ScheduleProvider,
} from "@shared/contexts"

import { StreamerChatting } from "streamerChatting/components"
import { useValidation } from "@shared/hooks/useValidation"

function StreamerChattingPage() {
  useValidation()

  return (
    <ScheduleProvider>
      <LayerPopupProvider>
        <ChatProvider>
          <StreamerChatting />
        </ChatProvider>
      </LayerPopupProvider>
    </ScheduleProvider>
  )
}

export default StreamerChattingPage
